import { defineStore } from "pinia";

export const useMainStore = defineStore("mainStore", {
  state: () => ({
    snackbar: {
      text: "",
      link: null as string | null,
      display: false,
      color: "primary",
      variant: "flat" as "text" | "flat" | "elevated" | "tonal" | "outlined" | "plain",
    },
  }),
  actions: {
    resetSnackbar() {
      this.snackbar = {
        text: "",
        link: null as string | null,
        display: false,
        color: "primary",
        variant: "flat" as "text" | "flat" | "elevated" | "tonal" | "outlined" | "plain",
      }
    }
  }
});
